/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api, qs } from '@/lib/api';
import { useDebounced } from '@/lib/hooks';

/** Выбор клиента/контрагента с поиском по названию, ИНН или телефону. */
export function PartyPicker({ value, valueLabel, onChange, role, placeholder = 'Начните вводить название или ИНН' }: {
  value?: string | null; valueLabel?: string | null; onChange: (id: string | null, name?: string) => void; role?: 'client' | 'counterparty'; placeholder?: string;
}) {
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);
  const dq = useDebounced(q);
  const { data } = useQuery({
    queryKey: ['party-pick', dq, role], enabled: open && dq.length > 0,
    queryFn: () => api.get(`/parties${qs({ q: dq, role, pageSize: 10 })}`),
  });
  if (value && !open) {
    return (
      <div className="flex items-center gap-2">
        <div className="input flex-1 truncate bg-slate-50">{valueLabel ?? 'Выбрано'}</div>
        <button type="button" className="text-xs text-brand-700 hover:underline" onClick={() => { onChange(null); setOpen(true); }}>Изменить</button>
      </div>
    );
  }
  return (
    <div className="relative">
      <input className="input" value={q} placeholder={placeholder} onChange={(e) => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {open && data?.items?.length > 0 && (
        <div className="absolute z-20 mt-1 max-h-64 w-full overflow-y-auto rounded-md border border-slate-200 bg-white shadow-lg">
          {data.items.map((p: any) => (
            <button type="button" key={p.id} className="block w-full px-3 py-2 text-left text-sm hover:bg-slate-50"
              onMouseDown={() => { onChange(p.id, p.name); setQ(''); setOpen(false); }}>
              <div>{p.name}</div>
              {p.inn && <div className="text-xs text-slate-500">ИНН {p.inn}</div>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
